import { render, staticRenderFns } from "./RulesConfig.vue?vue&type=template&id=11268b83&scoped=true"
import script from "./RulesConfig.vue?vue&type=script&lang=js"
export * from "./RulesConfig.vue?vue&type=script&lang=js"
import style0 from "./RulesConfig.vue?vue&type=style&index=0&id=11268b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11268b83",
  null
  
)

export default component.exports